import { useEffect } from "react";

import { organizationByDescriptionIdSelector } from "Reducers/organization";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import {
  hasUnpaidOrdersDataSelector,
  organizationOrdersLoadingSelector
} from "../order.selectors";
import { getOrganizationOrdersThunk } from "../thunks/getOrganizationOrders.thunk";

export const useLoadOrders = (
  organizationId: string,
  userId?: string,
  ownerId?: string
) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(organizationOrdersLoadingSelector);

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );

  const hasUnpaidOrders = useAppSelector(state =>
    hasUnpaidOrdersDataSelector(state, {
      organizationId,
      ownerId,
      userId
    })
  );

  const data = useAppSelector(
    state => state.organizationOrder.data[organizationId]
  );

  const previous = data?.["previous"];
  const recurring = data?.["recurring"];

  const canRequestOrders = !!organization?.hasLink("orders");
  useEffect(() => {
    if (canRequestOrders)
      dispatch(getOrganizationOrdersThunk({ organizationId }));
  }, [dispatch, canRequestOrders, organizationId]);

  return {
    recurring,
    previous,
    loading,
    hasUnpaidOrders
  };
};
